module.exports = __webpack_public_path__ + "img/5.e3d756d4.png";